import { Service } from '../../../store/service/types';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import UpTransition from '../../../shared/UpTransition/UpTransition';
import { useState } from 'react';
import { SelectedValueType } from '../AddServiceDialog/parameter/parameterSelector';
import useComplexObject from '../AddServiceDialog/parameter/useComplexObject';
import { Trans, useTranslation } from 'react-i18next';
import ServiceDrawer from '../ServiceDrawer/ServiceDrawer';
import AddServiceDialog from '../AddServiceDialog/AddServiceDialog';
import { Pipeline as PipelineType } from '../../../store/data/types';

type Props = {
    open: boolean;
    pipeline: PipelineType | null;
    onClose: (success: boolean, name: string, service: Service | null, data: Record<string, SelectedValueType>) => void;
};

const AddServiceDialogBottom = ({ open, pipeline, onClose }: Props): JSX.Element => {
  const { t } = useTranslation();

  const [addServiceType, setAddServiceType] = useState(null as Service | null);
  const [name, setName] = useState('');
  const [parameters, updateParameters, resetParameters] = useComplexObject<SelectedValueType>({});

  const reset = () => {
    resetParameters();
    setName('');
  };

  const handleClose = (success: boolean) => () => {
    onClose(success, name, addServiceType, parameters);
    reset();
  };

  const handleAddServiceDialogClose = (success: boolean, name: string, data: Record<string, SelectedValueType>) => {
    setName(name);
    setAddServiceType(null);
    onClose(true, name, addServiceType, data);
    reset();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose(false)}
      aria-labelledby={'add-service-first-dialog-title'}
      aria-describedby={'add-service-first-dialog-description'}
      fullWidth={true}
      maxWidth={'md'}
      TransitionComponent={UpTransition}
    >
      {(
        <>
          <DialogTitle id={'add-service-first-dialog-title'}>
            Create Service
          </DialogTitle>
          <DialogContent>
           <ServiceDrawer onClick={service => setAddServiceType(service)} />
           <AddServiceDialog service={addServiceType} graphInfo={pipeline? pipeline.graph : null } onClose={handleAddServiceDialogClose} />
         </DialogContent>
          <DialogActions>
            <Button onClick={handleClose(false)}>
              <Trans>Cancel</Trans>
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};

export default AddServiceDialogBottom;